import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  catalog: {
    campaigns: []
  },
  campaignParentId: null,
  static: {},
  filters: [],
  partnersNoContract: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
